<template lang="html">
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>

      <!-- Nome -->
      <d-col md="6" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorFiled('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Barcode -->
      <d-col md="3" class="form-group">
        <label for="feBarcode">Código de barras</label>
        <d-form-input type="text" v-model="model.main_variation.barcode" id="feBarcode" placeholder="Código de barras" />
      </d-col>

      <!-- Price -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Preço</label>
        <d-input-group prepend="R$">
          <input-currency
            model-index="price"
            placeholder="Total"
            :model="model.main_variation"
          ></input-currency>
        </d-input-group>
      </d-col>

    </d-form-row>

    <d-form-row>

      <!-- Brand -->
      <d-col md="3" class="form-group">
        <label for="feBrand">Marca</label>
        <d-form-input type="text" v-model="model.brand" id="feBrand" placeholder="Marca" />
      </d-col>

      <!-- GrossWeight -->
      <d-col md="3" class="form-group">
        <label for="feGrossWeight">Peso bruto</label>
        <d-input-group append="g">
          <d-form-input type="number" class="text-right" v-model="model.main_variation.gross_weight" id="feGrossWeight" placeholder="Peso bruto" />
        </d-input-group>
      </d-col>

      <!-- NetWeight -->
      <d-col md="3" class="form-group">
        <label for="feNetWeight">Peso líquido</label>
        <d-input-group append="g">
          <d-form-input type="number" class="text-right" v-model="model.main_variation.net_weight" id="feNetWeight" placeholder="Peso líquido" />
        </d-input-group>
      </d-col>

      <!-- Unit Type Id -->
      <d-col md="3" class="form-group">
        <label for="fePrice">Unidade de medida</label>
        <d-select
          :state="hasErrorFiled('unit_type_id')"
          v-model="model.unit_type_id"
          :options="productUnits"
          value-field="id"
          text-field="name"
        >
        </d-select>
        <d-form-invalid-feedback>Unidade de medida é obrigatório</d-form-invalid-feedback>
      </d-col>
    </d-form-row>

    <d-form-row>

      <!-- Description -->
      <d-col md="12" class="form-group">
        <label for="feDescription">Descrição</label>
        <textarea id="feDescription" v-model="model.description" rows="5" class="form-control"></textarea>
      </d-col>

    </d-form-row>

    <d-form-row v-if="model.id > 0 && model.id != 'new'">

      <d-col cols="12">
        <material></material>
        <variations></variations>
        <product-variations></product-variations>
      </d-col>

    </d-form-row>

  </d-form>

</template>

<script>
import { mapActions } from 'vuex';
import mixin from '_common/mixins/ValidateForm';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import InputCurrency from '_shared/InputCurrency.vue';
import ProductService from '_services/rest/modules/product';
import Variations from './Variations.vue';
import Material from './Material.vue';
import ProductVariations from './ProductVariations.vue';
import { MODEL, _LOAD_MODEL_, _SAVE_PRODUCT_SUCCESS_, PRODUCT_UNITS_OPTIONS } from './ProductModel';

export default {
  name: 'product-form',
  mixins: [mixin],
  components: {
    Loader,
    Variations,
    Material,
    InputCurrency,
    ProductVariations,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
      errors: {
        name: { required: false },
        phone: { required: false },
        unit_type_id: { required: false },
        contacts_name: { required: false },
      },
    };
  },
  computed: {
    productUnits() {
      const { productUnits } = this.$store.state.product;
      if (productUnits && productUnits.length) {
        return productUnits;
      }
      return PRODUCT_UNITS_OPTIONS;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'setProduct',
      'activeAlert',
      'getProductUnits',
    ]),
    createProduct() {
      ProductService.save(this.model)
        .then(response => {
          this.success(response);
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    getOptions() {
      if (!this.$store.state.product.productUnits) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductUnits()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    save() {
      if (this.checkForm()) {
        if (this.model.id) {
          return this.updateProduct();
        }
        return this.createProduct();
      }
      return null;
    },
    success(productSaved) {
      this.activeAlert({ message: 'Produto salvo com sucesso', theme: 'success' });
      this.setProduct(productSaved);
      Events.$emit(_SAVE_PRODUCT_SUCCESS_, productSaved);
    },
    updateProduct() {
      ProductService.save(this.model)
        .then(response => {
          this.success(response);
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
    this.getOptions();
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
